module.exports = __webpack_public_path__ + "img/icon-history_1.1f7f11f.png";